import { colorsConfig } from "../../../config/colors.config"

export const footerConfig = {
    backgroundColor: colorsConfig.cardBg,
    color: colorsConfig.textSecondary,
    padding: "0.8rem",
    textAlign: "center",
}

export const footerOptionsConfig = {
    cursor: "pointer",
    fontSize: "0.9rem",
    lineHeight: 1.5,
    borderRadius: "6px",
    borderWidth: "1px",
    borderLeftWidth: "4px",
    iconSize: "1.25rem",
    gap: "0.6rem",
}